/**
 * Server Sent Events クライアント
 */
class SseClient {
  /**
   * コンストラクタ
   */
  constructor() {
    this.eventSource = null
  }

  /**
   * Event Source を生成する
   * event, callback を与えた場合は同時に listner 登録も行う
   * @param {String} url URL
   * @param {String} event イベント名
   * @param {Function} callback コールバック関数
   * @param {Function} onerror エラー時コールバック
   */
  create(url, event, callback, onerror) {
    if (!this.eventSource) {
      this.eventSource = new EventSource(url, { withCredentials: true })
      this.eventSource.onerror = onerror
    }
    if (event && callback) {
      this.addListener(event, callback)
    }
  }

  /**
   * listener登録
   * @param {String} event イベント名
   * @param {Function} callback コールバック関数
   */
  addListener(event, callback) {
    if (!this.eventSource) return
    this.eventSource.addEventListener(
      event,
      (e) => {
        const json = JSON.parse(e.data)
        callback && callback(json)
      },
      false
    )
  }

  /**
   * listener削除
   * @param {String} event イベント名
   * @param {Function} callback コールバック関数
   */
  removeListener(event, callback) {
    this.eventSource && this.eventSource.removeEventListener(event, callback)
  }

  /**
   * Event Source を終了する
   */
  close() {
    if (this.eventSource) {
      this.eventSource.close()
      delete this.eventSource
      this.eventSource = null
    }
  }
}

export default new SseClient()
